import DetailedOffers from "../../components/molecules/detailedOffers";
import Footer from "../../components/molecules/footer";
import Header from "../../components/molecules/header";

const OffersPage = () => {
  return (
    <>
      <Header />
      <main>
        <DetailedOffers />
      </main>
      <Footer />
    </>
  );
};

export default OffersPage;
